import { SVGProps } from 'react';

const ChartBarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="41"
      height="36"
      viewBox="0 0 41 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 1V0H24V1H25ZM36.2 1H37.2V0H36.2V1ZM36.2 34.6V35.6H37.2V34.6H36.2ZM25 34.6H24V35.6H25V34.6ZM3.2 34.6C3.2 35.1523 3.64772 35.6 4.2 35.6C4.75228 35.6 5.2 35.1523 5.2 34.6H3.2ZM4.2 20.2V19.2C3.64772 19.2 3.2 19.6477 3.2 20.2H4.2ZM13.8 21.2C14.3523 21.2 14.8 20.7523 14.8 20.2C14.8 19.6477 14.3523 19.2 13.8 19.2V21.2ZM39.4 35.6C39.9523 35.6 40.4 35.1523 40.4 34.6C40.4 34.0477 39.9523 33.6 39.4 33.6V35.6ZM1 33.6C0.447715 33.6 0 34.0477 0 34.6C0 35.1523 0.447715 35.6 1 35.6V33.6ZM12.8 34.6C12.8 35.1523 13.2477 35.6 13.8 35.6C14.3523 35.6 14.8 35.1523 14.8 34.6H12.8ZM13.8 10.6V9.6C13.2477 9.6 12.8 10.0477 12.8 10.6H13.8ZM25 11.6C25.5523 11.6 26 11.1523 26 10.6C26 10.0477 25.5523 9.6 25 9.6V11.6ZM25 1V2H36.2V1V0H25V1ZM36.2 1H35.2V34.6H36.2H37.2V1H36.2ZM36.2 34.6V33.6H25V34.6V35.6H36.2V34.6ZM25 34.6H26V1H25H24V34.6H25ZM4.2 34.6H5.2V20.2H4.2H3.2V34.6H4.2ZM4.2 20.2V21.2H13.8V20.2V19.2H4.2V20.2ZM39.4 34.6V33.6H1V34.6V35.6H39.4V34.6ZM13.8 34.6H14.8V10.6H13.8H12.8V34.6H13.8ZM13.8 10.6V11.6H25V10.6V9.6H13.8V10.6Z"
        fill="url(#paint0_linear_3623_13335)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3623_13335"
          x1="20.2002"
          y1="0.999999"
          x2="11.1081"
          y2="31.927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChartBarIcon;
